/* Publish by EComposer at 2026-10-13 12:55:46*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1evkugqa7ao"]=  window.__ectimmers["ecom-1evkugqa7ao"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-1evkugqa7ao').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1evkugqa7ao', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hz8lzexqfd8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hz8lzexqfd8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6hfd2urpcjc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6hfd2urpcjc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iwocwrs5c1d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iwocwrs5c1d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ogp7nca76jj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ogp7nca76jj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cpsu2hhhzrl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cpsu2hhhzrl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cd9joyklduh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cd9joyklduh', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-fekmah2ks2i"]=  window.__ectimmers["ecom-fekmah2ks2i"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-fekmah2ks2i"]["bz2przan2"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-fekmah2ks2i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fekmah2ks2i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-697ia6w45j2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-697ia6w45j2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p8c9miculon').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p8c9miculon', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1byjqw5gw9t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1byjqw5gw9t', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6sgke7s2azd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6sgke7s2azd', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1tocomtoo0jj"]=  window.__ectimmers["ecom-1tocomtoo0jj"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-1tocomtoo0jj"]["5uks9qpoe"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-1tocomtoo0jj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1tocomtoo0jj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2xw52rei8qj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2xw52rei8qj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yrnvet1keu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yrnvet1keu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ovcvlspczk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ovcvlspczk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xsg6tgs2z3r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xsg6tgs2z3r', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1cdlfi9apnu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1cdlfi9apnu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ywmdwjvnup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ywmdwjvnup', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x58utnjc27l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x58utnjc27l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}